<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/E0HNRb/tc-custom/9781468303759.jpg?1713839876559" alt="This image is the cover for the book Beyond Sleep"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beyond Sleep
      </h1>
      <p class="bookDescription body article font2">
        <b>“In this moving tragicomedy,” an academic hoping to secure his reputation gains “self-knowledge . . . achieved at great cost” in this literary novel. (<i>Publishers Weekly)</i></b><br/>  <br/> Alfred Issendorf is a Dutch geology student obsessed with the thought of dying without a major scientific discovery to his name. Setting off on a geological expedition which brings him to Norway, Issendorf is out to prove that craters in the landscape are actually holes caused by the impact of meteorites. But his trip quickly turns sour: the unearthly atmosphere of the midnight sun makes him paranoid; nights are too hot; clouds of mosquitoes steal his sleep; he is exhausted. Suspicion takes over and he sees secret plots against his scientific work by everyone and everything. Haunted by down-and-out scientists, the ghost of his dead father, and apparitions of ancient animals, Issendorf's character is both naïve and cynical, ambitious and distrustful, grandiose and talentless and his story is one of adventure and discovery, psychology and pride.<br/>  <br/><i>Beyond Sleep</i> is a classic of post-war European literature: the saga of a man at the limits of the civilized world.<br/>  <br/> “An exceptionally well-crafted novel. . . . [the characters are] wryly funny, and in that lies the novel's brilliance. —<i>Booklist</i><br/>  <br/> “An unusual and intriguing book, and a welcome introduction to the work of a neglected 20th-century master. —<i>Kirkus Reviews</i><br/>  <br/> "A novel of worldly disengagement trembling on the edge of tragedy, all the more comic for being related in Hermans' best poker-faced manner" —J.M. Coetzee, Nobel Prize Laureate 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Willem Frederik Hermans
      </h2>
      
      <p class="authorDescription body article">Willem Frederik Hermans (1921-1995) is widely considered perhaps the most important Western European author to emerge from the postwar period. His novels, short stories, essays, and philosophical and scientific writings represent a major body of work being discovered in the United States.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c36eaaa4